export const COUNTRY_CODES_MAP = {
  default: 'ID',
  hk: 'HK',
  id: 'ID',
  my: 'MY',
  ph: 'PH',
  sg: 'SG',
  th: 'TH',
  tw: 'TW',
  vn: 'VN',
} as const;
